import { openSalesIQChat } from '../utils/openSalesIQChat';
import CallButton from './CallButton';

export default function SupportSection() {
  return (
    <section className="t7-section t7-section--green">
      <div className="container">
        <div className="t7-cta-row">
          <div>
            <p className="t7-kicker">Live assistance</p>
            <h2 className="t7-title">Expert support when you need it</h2>
            <p className="t7-lead mb-0">
              Installation stuck? Migrating to a new PC? Sync acting up? Call or chat with our team
              for clear, step-by-step guidance.
            </p>
          </div>
          <div className="t7-cta-row__action">
            <CallButton className="t7-btn t7-btn--solid" />
            <button type="button" className="t7-btn t7-btn--outline" onClick={openSalesIQChat}>
              Open Live Chat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
